<template>
  <div class="container">
    <!-- <img
      class="header"
      :src="covers && covers.length > 0 ? covers[0].imgUrl : ''"
    />
     -->
    <img class="header" src="../assets/header1.jpg" />
    <div class="content-tabs">
      <div style="width: 100%; display: flex; justify-content: center">
        <div
          style="
            width: 90vw;
            border-radius: 12.5px;
            height: 25px;
            line-height: 25px;
            color: #5190d5;
            font-size: 14px;
            font-weight: 500;
            background-color: #fff;
            padding: 5px 0;
            margin-bottom: 4px;
          "
        >
          你是第{{ " " + userIndex + " " }}位访问者
        </div>
      </div>

      <van-tabs
        color="#5190D5"
        background="#f8f8f8"
        title-active-color="#5190D5"
        title-inactive-color="#5190D5"
        v-model:active="active"
        sticky
        animated
        lazy-render
        @click-tab="onClickTab"
      >
        <!-- @scroll="onScroll" -->
        <van-tab
          v-for="(tab, index) in tabsArray"
          :title="tab.describe"
          :name="tab.type"
          :key="index"
        >
          <template #title>
            <div :class="tab.type == active ? 'slot-title' : 'lib-title'">
              {{ tab.describe }}
            </div>
          </template>
          <template #default>
            <ContentCell type="tipoff" v-if="tab.type == 'tipoff'" />
            <NewsList v-if="tab.type == 'news'" />
            <ContentCell type="advice" v-if="tab.type == 'advice'" />
            <ContentCell type="qa" v-if="tab.type == 'qa'" />
            <MyCell v-if="tab.type == 'myCell'" />
          </template>
        </van-tab>
      </van-tabs>
    </div>
    <div
      class="help-btn"
      :class="fadeCss"
      @click="handleClick"
      v-if="
        (active == 'tipoff' || active == 'advice' || active == 'qa') && showBtn
      "
    >
      <img src="../assets/submit.png" alt="" />
    </div>
  </div>
  <Statement />
</template>

<script>
import {
  List,
  PullRefresh,
  Icon,
  Button,
  Image as VanImage,
  ImagePreview,
  Divider,
  Tab,
  Tabs,
} from "vant";
import { ref, computed, onMounted, reactive } from "vue";
import { useStore } from "vuex";
import ContentCell from "@/views/ContentCell.vue";
import NewsList from "@/views/NewsList.vue";
import MyCell from "@/views/MyCell.vue";
// import useShare from "@/composiables/useShare.js";
import { useRouter } from "vue-router";
import { wxshareInit } from "@/plugins/wechatSDK.js";
import "@/plugins/bridge.js";
import Statement from "@/components/Statement.vue";

export default {
  name: "Home",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [VanImage.name]: VanImage,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [List.name]: List,
    [Divider.name]: Divider,
    [ImagePreview.Component.name]: ImagePreview.Component,
    ContentCell,
    NewsList,
    MyCell,
    Statement,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const active = ref("tipoff");
    const page = ref(1);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const showBtn = ref(true);
    const fadeCss = ref("fadeIn");
    const lastScrollNumber = ref(0);
    const tabsArray = reactive([
      {
        describe: "投诉监督",
        type: "tipoff",
      },
      {
        describe: "建言献策",
        type: "advice",
      },
      {
        describe: "追踪报道",
        type: "news",
      },
      {
        describe: "我的",
        type: "myCell",
      },
    ]);

    onMounted(() => {
      store.dispatch("getAppEnv");
      const { aplus_queue } = window;
      aplus_queue.push({
        action: "aplus.sendPV",
        arguments: [{ is_auto: false }],
      });
      aplus_queue.push({
        action: "aplus.record",
        arguments: [
          "$$_exposure",
          "EXP",
          {
            page: "civilization",
          },
        ],
      });
    });

    const onClickTab = () => {
      // store.state.tabActive = tab.name;
    };

    // const userAgentString = navigator.userAgent.toLowerCase();
    const handleClick = () => {
      // if (userAgentString.indexOf("zsrbapp") < 0) {
      //   store.commit("updateShowStatement", true);
      //   console.log(store.state.showStatement);
      // } else {
      router.push("/submit/");
      // }
    };

    const onScroll = (scroll) => {
      if (scroll.scrollTop > lastScrollNumber.value) {
        fadeCss.value = "fadeOut";
        setTimeout(() => {
          showBtn.value = false;
        }, 300);
      } else {
        fadeCss.value = "fadeIn";
        showBtn.value = true;
      }
      lastScrollNumber.value = scroll.scrollTop;
    };

    return {
      tabsArray,
      active,
      page,
      loading,
      finished,
      refreshing,
      contents: computed(() => store.state.contents),
      covers: computed(() => store.state.covers),
      onClickTab,
      handleClick,
      onScroll,
      showBtn,
      fadeCss,
      lastScrollNumber,
      userIndex: Math.floor(
        (new Date().getTime() / 1000 - 1681282889) / 120 + 303299
      ),
    };
  },
  created() {
    window.ZsrbApp.call("shareInfo", {
      title: "中山市“文明眼”网上监督平台",
      img: "https://zsrbactivity.zsnews.cn" + require("../assets/zsplus.jpg"),
      desc: "全民齐参与 共创典范城",
      url: "https://zsrbactivity.zsnews.cn/vue/civilization/",
    });

    wxshareInit({
      title: "中山市“文明眼”网上监督平台",
      imgUrl:
        "https://zsrbactivity.zsnews.cn" + require("../assets/zsplus.jpg"),
      description: "全民齐参与 共创典范城",
      url: "https://zsrbactivity.zsnews.cn/vue/civilization/",
      successMethod: "",
    });
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin: 0 0 0 0;
  min-height: 100vh;
  background: #f8f8f8;
}

.content-tabs {
  margin-top: -5vw;
  // padding-top: 10px;
  .slot-title {
    font-weight: 600;
    font-size: 17px;
    height: 24px;
    display: inline-block;
    line-height: 22px;
  }
  .lib-title {
    font-size: 16px;
    height: 24px;
    display: inline-block;
    line-height: 22px;
  }
}

.header {
  width: 100%;
  height: auto;
}
.content {
  padding-bottom: 90px;
  --van-pull-refresh-head-text-color: white;
}

.content-list {
  --van-list-text-color: #5190d5;
}

.btn-div {
  position: fixed;
  bottom: 35px;
  z-index: 100;
  margin: 0px auto;
  right: 0px;
  left: 0px;
}
.help-btn {
  position: fixed;
  bottom: 55px;
  z-index: 100;
  margin: 0px auto;
  right: 10px;
  img {
    width: 70px;
    height: 70px;
  }
}

.fadeIn {
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-iteration-count: 1;
}
.fadeOut {
  animation-name: fadeOut;
  animation-duration: 1s;
  animation-iteration-count: 1;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}
</style>
